export default {
  "app-footer": () => import("/home/forge/career.proxify.io/releases/20261023135732/layouts/AppFooter/AppFooter.vue"),
  "app-header": () => import("/home/forge/career.proxify.io/releases/20261023135732/layouts/AppHeader/AppHeader.vue"),
  newsletter: () => import("/home/forge/career.proxify.io/releases/20261023135732/layouts/Newsletter/Newsletter.vue"),
  default: () => import("/home/forge/career.proxify.io/releases/20261023135732/layouts/default.vue")
}